<template>
	<div>
		<div class="d-flex align-center ao-drag-n-drop" >
			<ao-icon v-if="showIcon"
				iconColor="textSecondary"
				iconName="dragNDrop" />
			<slot/>
		</div>
		<v-divider v-if="showDivider"/>
	</div>
</template>
<script>
export default {
    name: 'AoDragNDropListItem',
    props: {
		showIcon: {
			type: Boolean,
			default: true
		},
        showDivider: {
			type: Boolean,
			default: false
		},
	},
}
</script>

<style lang="scss">
</style>